export default __webpack_public_path__ + "static/media/KZ.M.08.2030 black.f3744db9.svg";